import React from "react";
import * as FaIcons from "react-icons/fa";

import educationLevels from "../../../data/educationLevels";
import phoneTypes from "../../../data/phoneTypes";
import relationshipList from "../../../data/relationshipList";

const R33Parent2Information = ({
  formData,
  onFormDataChange,
  validationCheck,
}) => {
  const {
    registerForIntercession,
    firstName,
    age,
    pg2HighestLevelOfEducation,
    permissionParentContact,
    pg2RelationshipToStudent,
    pg2FirstName,
    pg2LastName,
    pg2PrimaryPhone,
    pg2PrimaryPhoneType,
    pg2PrimaryEmail,
    liveWithPg2
  } = formData;

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePhone = (number) => {
    const re = /^\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
    return re.test(String(number).toLowerCase());
  };

  return (
    <>
      {/* Parent/Guardian Information */}
      <div className="sub-form">
        <h3>Parent 2 Information</h3>
        {!registerForIntercession && (
          <>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  What is {firstName === "" ? "the Student" : firstName}'s
                  Parent 2/Guardian's Highest Level of Education?
                </h4>
                {/* <FaIcons.FaAsterisk className="asterisk-icon" /> */}
              </div>
              <select
                name="pg2HighestLevelOfEducation"
                value={pg2HighestLevelOfEducation}
                onChange={(e) => onFormDataChange(e)}
                style={{
                  border:
                    validationCheck && !(pg2HighestLevelOfEducation !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <option value="">Please Select </option>
                {educationLevels.map((item) => {
                  return <option value={item}>{item}</option>;
                })}
              </select>
            </div>
          </>
        )}
        {/* {age >= 18 && (
          <>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  Do we have permission to contact{" "}
                  {firstName === "" ? "the Student" : firstName}'s parent or
                  gaurdian about school?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border:
                    validationCheck &&
                    !(
                      permissionParentContact["yes"] ||
                      permissionParentContact["no"]
                    )
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={permissionParentContact["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="permissionParentContact"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={permissionParentContact["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="permissionParentContact"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>
          </>
        )} */}

        {/* {(permissionParentContact["yes"] || age < 18) && ( */}
          <>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  What is the Parent 2/Guardin's Relationship to{" "}
                  {firstName === "" ? "the Student" : firstName}?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <select
                name="pg2RelationshipToStudent"
                value={pg2RelationshipToStudent}
                onChange={(e) => onFormDataChange(e)}
                style={{
                  border:
                    validationCheck && !(pg2RelationshipToStudent!== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <option value="">Please Select </option>
                {relationshipList.map((item) => {
                  return <option value={item}>{item}</option>;
                })}
              </select>
            </div>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                What is {firstName === "" ? "the Student" : firstName}'s Parent 2/Guardian’s First Name?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="pg2FirstName"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={pg2FirstName}
                style={{
                  border:
                    validationCheck && !(pg2FirstName !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                What is {firstName === "" ? "the Student" : firstName}'s  Parent 2/Guardian’s Last Name?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="pg2LastName"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={pg2LastName}
                style={{
                  border:
                    validationCheck && !(pg2LastName !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                What is {firstName === "" ? "the Student" : firstName}'s  Parent 2/Guardian's Primary Phone Number?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="pg2PrimaryPhone"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                placeholder="XXX-XXX-XXXX"
                value={pg2PrimaryPhone}
                style={{
                  border:
                    validationCheck &&
                    (pg2PrimaryPhone === "" || !validatePhone(pg2PrimaryPhone))
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
              {validationCheck && !validatePhone(pg2PrimaryPhone) && (
                <p className="validEmail">
                  Please provide a valid phone number in the following format
                  XXX-XXX-XXXX
                </p>
              )}
            </div>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                What is {firstName === "" ? "the Student" : firstName}'s Parent 2/Guardian's Primary Phone Type?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <select
                name="pg2PrimaryPhoneType"
                value={pg2PrimaryPhoneType}
                onChange={(e) => onFormDataChange(e)}
                style={{
                  border:
                    validationCheck && !(pg2PrimaryPhoneType !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <option value="">Please Select </option>
                {phoneTypes.map((item) => {
                  return <option value={item}>{item}</option>;
                })}
              </select>
            </div>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                What is {firstName === "" ? "the Student" : firstName}'s Parent 2/Guardian’s Email?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="pg2PrimaryEmail"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={pg2PrimaryEmail}
                style={{
                  border:
                    validationCheck &&
                    (pg2PrimaryEmail === "" || !validateEmail(pg2PrimaryEmail))
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
              {validationCheck && !validateEmail(pg2PrimaryEmail) && (
                <p className="validEmail">
                  Please provide a valid email address
                </p>
              )}
            </div>
          
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                Does {firstName === "" ? "the Student" : firstName} Live With
              Parent 2?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border:
                    validationCheck && !(liveWithPg2["yes"] || liveWithPg2["no"])
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={liveWithPg2["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="liveWithPg"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={liveWithPg2["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="liveWithPg"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>
          
          </>
        {/* // )} */}
      </div>
    </>
  );
};

export default R33Parent2Information;
